// src/routes.js
import Dashboard from '@pages/Dashboard';
import Profile from '@pages/profile/Profile';
import Account from '@pages/account/Account';
import AccountAdd from '@pages/account/AccountAdd';
import AccountEdit from '@pages/account/AccountEdit';
import EmailConfig from '@pages/emailConfig/EmailConfig';
import EmailConfigAdd from '@pages/emailConfig/EmailConfigAdd';
import EmailConfigEdit from '@pages/emailConfig/EmailConfigEdit';
import LoginHistory from '@app/pages/report/countLogin/LoginHistory';
import StatisticLoginHistory from '@app/pages/report/countLogin/StatisticLoginHistory';
import Log from '@pages/log/Log';
import ApiRoleMapping from '@app/pages/apiRoleMapping/ApiRoleMapping';
import ApiRoleMappingAdd from '@app/pages/apiRoleMapping/ApiRoleMappingAdd';
import ApiRoleMappingEdit from '@app/pages/apiRoleMapping/ApiRoleMappingEdit';


import { URI_INTERNAL } from './utils/pathLocations';
import OpeniddictApplication from '@app/pages/openiddictApplication/OpeniddictApplication';
import OpeniddictApplicationAdd from '@app/pages/openiddictApplication/OpeniddictApplicationAdd';
import OpeniddictApplicationEdit from '@app/pages/openiddictApplication/OpeniddictApplicationEdit';
import RoleAccount from '@app/pages/roleAccount/RoleAccount';
import RoleAccountAdd from '@app/pages/roleAccount/RoleAccountAdd';
import RoleAccountEdit from '@app/pages/roleAccount/RoleAccountEdit';
import KySo from '@app/pages/kySo/KySo';

// AppDungChung
import DonVi from '@app/pages/appDungChung/donVi/DonVi';
import DonViAdd from '@app/pages/appDungChung/donVi/DonViAdd';
import DonViEdit from '@app/pages/appDungChung/donVi/DonViEdit';
import ChucVu from '@app/pages/appDungChung/chucVu/ChucVu';
import ChucVuAdd from '@app/pages/appDungChung/chucVu/ChucVuAdd';
import ChucVuEdit from '@app/pages/appDungChung/chucVu/ChucVuEdit';
import ChuyenMon from '@app/pages/appDungChung/chuyenMon/ChuyenMon';
import ChuyenMonAdd from '@app/pages/appDungChung/chuyenMon/ChuyenMonAdd';
import ChuyenMonEdit from '@app/pages/appDungChung/chuyenMon/ChuyenMonEdit';
import DonViDaoTao from '@app/pages/appDungChung/donViDaoTao/DonViDaoTao';
import DonViDaoTaoAdd from '@app/pages/appDungChung/donViDaoTao/DonViDaoTaoAdd';
import DonViDaoTaoEdit from '@app/pages/appDungChung/donViDaoTao/DonViDaoTaoEdit';
import HinhThucDaoTao from '@app/pages/appDungChung/hinhThucDaoTao/HinhThucDaoTao';
import HinhThucDaoTaoAdd from '@app/pages/appDungChung/hinhThucDaoTao/HinhThucDaoTaoAdd';
import HinhThucDaoTaoEdit from '@app/pages/appDungChung/hinhThucDaoTao/HinhThucDaoTaoEdit';
import NganhDaoTao from '@app/pages/appDungChung/nganhDaoTao/NganhDaoTao';
import NganhDaoTaoAdd from '@app/pages/appDungChung/nganhDaoTao/NganhDaoTaoAdd';
import NganhDaoTaoEdit from '@app/pages/appDungChung/nganhDaoTao/NganhDaoTaoEdit';
import TrinhDo from '@app/pages/appDungChung/trinhDo/TrinhDo';
import TrinhDoAdd from '@app/pages/appDungChung/trinhDo/TrinhDoAdd';
import TrinhDoEdit from '@app/pages/appDungChung/trinhDo/TrinhDoEdit';
import XepLoaiDaoTao from '@app/pages/appDungChung/xepLoaiDaoTao/XepLoaiDaoTao';
import XepLoaiDaoTaoAdd from '@app/pages/appDungChung/xepLoaiDaoTao/XepLoaiDaoTaoAdd';
import XepLoaiDaoTaoEdit from '@app/pages/appDungChung/xepLoaiDaoTao/XepLoaiDaoTaoEdit';
import DoiTuong from '@app/pages/appDungChung/doiTuong/DoiTuong';
import DoiTuongAdd from '@app/pages/appDungChung/doiTuong/DoiTuongAdd';
import DoiTuongEdit from '@app/pages/appDungChung/doiTuong/DoiTuongEdit';
import AccountInfo from '@app/pages/appDungChung/accountInfo/AccountInfo';
import AccountInfoAdd from '@app/pages/appDungChung/accountInfo/AccountInfoAdd';
import AccountInfoEdit from '@app/pages/appDungChung/accountInfo/AccountInfoEdit';
import QuaTrinhDaoTao from '@app/pages/appDungChung/quaTrinhDaoTao/QuaTrinhDaoTao';
import QuaTrinhDaoTaoAdd from '@app/pages/appDungChung/quaTrinhDaoTao/QuaTrinhDaoTaoAdd';
import QuaTrinhDaoTaoEdit from '@app/pages/appDungChung/quaTrinhDaoTao/QuaTrinhDaoTaoEdit';
import QuocGia from '@app/pages/appDungChung/quocGia/QuocGia';
import QuocGiaAdd from '@app/pages/appDungChung/quocGia/QuocGiaAdd';
import QuocGiaEdit from '@app/pages/appDungChung/quocGia/QuocGiaEdit';

const rawRoutes = [
  // dashboard
  {
    path: "/", // bạn có thể thêm HOME_PATH = '/'
    exact: true,
    component: Dashboard,
    isPublic: false,
    // label:      'Dashboard',
    controller: '',
    action: '',
    label: "Dashboard",
    menu: true,
    isPublic: false,
  },
  // profile
  {
    path: "/profile",
    exact: true,
    component: Profile,
    isPublic: false,
    // controller: 'Profile',
    // action:     'View',
    // label:      'Profile',
    controller: '',
    action: '',
    label: "Thông tin cá nhân",
    menu: false,
    isPublic: false,
  },
  // account
  {
    path: URI_INTERNAL.ACCOUNT_PATH,
    exact: true,
    component: Account,
    isPublic: false,
    controller: 'Account',
    // controller: '',
    action: '',
    label: "Tài khoản",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNT_PATH_ADD,
    exact: true,
    component: AccountAdd,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNT_PATH_EDIT,
    exact: true,
    component: AccountEdit,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  //role
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_PATH,
    exact: true,
    component: RoleAccount,
    isPublic: false,
    controller: 'Role',
    // controller: '',
    action: '',
    label: "Quyền",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_CREATE_PATH,
    exact: true,
    component: RoleAccountAdd,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_EDIT_PATH,
    exact: true,
    component: RoleAccountEdit,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  // email config
  {
    path: URI_INTERNAL.EMAILCONFIG_PATH,
    exact: true,
    component: EmailConfig,
    isPublic: false,
    controller: 'EmailConfig',
    // controller: '',
    action: '',
    label: "Email gửi thông báo",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.EMAILCONFIG_CREATE_PATH,
    exact: true,
    component: EmailConfigAdd,
    isPublic: false,
    // controller: 'EmailConfig',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.EMAILCONFIG_EDIT_PATH,
    exact: true,
    component: EmailConfigEdit,
    isPublic: false,
    // controller: 'EmailConfig',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  // reports
  {
    path: URI_INTERNAL.LOGIN_HISTORY_PATH,
    exact: true,
    component: LoginHistory,
    isPublic: false,
    controller: 'LoginHistory',
    // controller: '',
    action: '',
    label: "Lịch sử đăng nhập",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.STATISTIC_HISTORY_PATH,
    exact: true,
    component: StatisticLoginHistory,
    isPublic: false,
    // controller: 'Report',
    controller: '',
    action: '',
    label: "Thống kê lịch sử đăng nhập",
    menu: true,
    isPublic: false,
  },
  // api-role-mapping
  {
    path: URI_INTERNAL.APIROLEMAPPING_PATH,
    exact: true,
    component: ApiRoleMapping,
    isPublic: false,
    controller: 'ApiRoleMapping',
    // controller: '',
    action: '',
    label: "Phân quyền API",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.APIROLEMAPPING_CREATE_PATH,
    exact: true,
    component: ApiRoleMappingAdd,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Them',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.APIROLEMAPPING_EDIT_PATH,
    exact: true,
    component: ApiRoleMappingEdit,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Sua',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_PATH,
    exact: true,
    component: OpeniddictApplication,
    isPublic: false,
    controller: 'OpeniddictApplication',
    // controller: '',
    action: '',
    label: "Ứng dụng đăng ký",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_CREATE_PATH,
    exact: true,
    component: OpeniddictApplicationAdd,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Them',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_EDIT_PATH,
    exact: true,
    component: OpeniddictApplicationEdit,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Sua',
    label: "",
    menu: false,
    isPublic: false,
  },
  // log
  {
    path: URI_INTERNAL.LOG_PATH,
    exact: true,
    component: Log,
    isPublic: false,
    controller: 'Log',
    // controller: '',
    action: '',
    label: "Xem log",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.KYSO_PATH,
    exact: true,
    component: KySo,
    isPublic: false,
    controller: 'KySo',
    // controller: '',
    action: '',
    label: "Ký số",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DONVI_PATH,
    exact: true,
    component: DonVi,
    isPublic: false,
    controller: 'DonVi',
    action: '',
    label: "Đơn vị",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DONVI_CREATE_PATH,
    exact: true,
    component: DonViAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DONVI_EDIT_PATH,
    exact: true,
    component: DonViEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUCVU_PATH,
    exact: true,
    component: ChucVu,
    isPublic: false,
    controller: 'ChucVu',
    action: '',
    label: "Chức vụ",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUCVU_CREATE_PATH,
    exact: true,
    component: ChucVuAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUCVU_EDIT_PATH,
    exact: true,
    component: ChucVuEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUYENMON_PATH,
    exact: true,
    component: ChuyenMon,
    isPublic: false,
    controller: 'ChuyenMon',
    action: '',
    label: "Chuyên môn",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUYENMON_CREATE_PATH,
    exact: true,
    component: ChuyenMonAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUYENMON_EDIT_PATH,
    exact: true,
    component: ChuyenMonEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DONVIDAOTAO_PATH,
    exact: true,
    component: DonViDaoTao,
    isPublic: false,
    controller: 'DonViDaoTao',
    action: '',
    label: "Đơn vị đào tạo",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DONVIDAOTAO_CREATE_PATH,
    exact: true,
    component: DonViDaoTaoAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DONVIDAOTAO_EDIT_PATH,
    exact: true,
    component: DonViDaoTaoEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.HINHTHUCDAOTAO_PATH,
    exact: true,
    component: HinhThucDaoTao,
    isPublic: false,
    controller: 'HinhThucDaoTao',
    action: '',
    label: "Hình thức đào tạo",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.HINHTHUCDAOTAO_CREATE_PATH,
    exact: true,
    component: HinhThucDaoTaoAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.HINHTHUCDAOTAO_EDIT_PATH,
    exact: true,
    component: HinhThucDaoTaoEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.NGANHDAOTAO_PATH,
    exact: true,
    component: NganhDaoTao,
    isPublic: false,
    controller: 'NganhDaoTao',
    action: '',
    label: "Ngành dào tạo",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.NGANHDAOTAO_CREATE_PATH,
    exact: true,
    component: NganhDaoTaoAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.NGANHDAOTAO_EDIT_PATH,
    exact: true,
    component: NganhDaoTaoEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.TRINHDO_PATH,
    exact: true,
    component: TrinhDo,
    isPublic: false,
    controller: 'TrinhDo',
    action: '',
    label: "Trình độ",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.TRINHDO_CREATE_PATH,
    exact: true,
    component: TrinhDoAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.TRINHDO_EDIT_PATH,
    exact: true,
    component: TrinhDoEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.XEPLOAIDAOTAO_PATH,
    exact: true,
    component: XepLoaiDaoTao,
    isPublic: false,
    controller: 'XepLoaiDaoTao',
    action: '',
    label: "Xêp loại đào tạo",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.XEPLOAIDAOTAO_CREATE_PATH,
    exact: true,
    component: XepLoaiDaoTaoAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.XEPLOAIDAOTAO_EDIT_PATH,
    exact: true,
    component: XepLoaiDaoTaoEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DOITUONG_PATH,
    exact: true,
    component: DoiTuong,
    isPublic: false,
    controller: 'DoiTuong',
    action: '',
    label: "Đối tượng",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DOITUONG_CREATE_PATH,
    exact: true,
    component: DoiTuongAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DOITUONG_EDIT_PATH,
    exact: true,
    component: DoiTuongEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNTINFO_PATH,
    exact: true,
    component: AccountInfo,
    isPublic: false,
    controller: 'AccountInfo',
    action: '',
    label: "Thông tin người dùng",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNTINFO_CREATE_PATH,
    exact: true,
    component: AccountInfoAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNTINFO_EDIT_PATH,
    exact: true,
    component: AccountInfoEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.QUATRINHDAOTAO_PATH,
    exact: true,
    component: QuaTrinhDaoTao,
    isPublic: false,
    controller: 'QuaTrinhDaoTao',
    action: '',
    label: "Quá trình đào tạo",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.QUATRINHDAOTAO_CREATE_PATH,
    exact: true,
    component: QuaTrinhDaoTaoAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.QUATRINHDAOTAO_EDIT_PATH,
    exact: true,
    component: QuaTrinhDaoTaoEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.QUOCGIA_PATH,
    exact: true,
    component: QuocGia,
    isPublic: false,
    controller: 'QuocGia',
    action: '',
    label: "Quốc gia",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.QUOCGIA_CREATE_PATH,
    exact: true,
    component: QuocGiaAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.QUOCGIA_EDIT_PATH,
    exact: true,
    component: QuocGiaEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
];

// function withController(routes) {
//   return routes.map(r => {
//     const name = r.component.displayName || r.component.name || '';
//     return {
//       ...r,
//       controller: r.controller ? r.controller : name,
//       // nếu chưa có label thì lấy tên component
//       label: r.label || name,
//     };
//   });
// }

function withController(routes) {
  return routes.map(r => ({
    ...r,
    // controller: r.controller,
    label: r.label || r.controller,
  }));
}

export const appRoutes = withController(rawRoutes);

export const menuGroups = [
  {
    title: "Dùng chung",
    icon: "fas fa-cog",
    children: appRoutes.filter(r =>
      r.menu && [
        "DonVi",
        "ChucVu",
        "ChuyenMon",
        "DonViDaoTao",
        "HinhThucDaoTao",
        "NganhDaoTao",
        "TrinhDo",
        "XepLoaiDaoTao",
        "DoiTuong",
        "AccountInfo",
        "QuaTrinhDaoTao",
        "QuocGia",
      ].includes(r.controller)
    )
  },
  {
    title: "Hệ thống",
    icon: "fas fa-cog",
    // Lấy tất cả route menu thuộc nhóm Hệ thống
    children: appRoutes.filter(r =>
      r.menu && [
        "Account",
        "Role",
        "EmailConfig",
        "ApiRoleMapping",
        "OpeniddictApplication",
        "Log",
        "KySo",
      ].includes(r.controller)
    )
  },
  {
    title: "Báo cáo",
    icon: "fas fa-table",
    // Lấy tất cả route menu thuộc nhóm Báo cáo
    children: appRoutes.filter(r =>
      r.menu && [
        "LoginHistory",
        "StatisticLoginHistory"
      ].includes(r.controller)
    )
  }
];
